const withPPE = ppe => prevPPEs => [...prevPPEs, ppe];

export default withPPE;
